<template>
  <div>
    <Form
      :model="formItem"
      :label-width="140"
      ref="formValidate"
      :rules="formValidate"
    >
      <div class="title">基础信息</div>
      <FormItem label=" " prop="spuCode">
        <Input
          v-model="formItem.brandName"
          disabled
          placeholder="请选择SPU"
          style="width: 50%"
        >
          <div slot="append">
            <Button
              type="primary"
              icon="ios-create"
              @click="selectSPUModalVisble = true"
              >选择SPU
            </Button>
          </div>
        </Input>
      </FormItem>
      <FormItem label="名称" prop="name">
        <Input
          v-model="formItem.name"
          placeholder="请输入名称"
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="产品代码" prop="prdCode">
        <Input
          v-model="formItem.prdCode"
          placeholder="请输入产品代码"
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="资金商ErpCode" prop="spErpCode">
        <Input
          v-model="formItem.spErpCode"
          placeholder="请输入资金商ErpCode"
          style="width: 50%"
        ></Input>
      </FormItem>

      <FormItem label="商品类型" prop="prdType">
        <!-- 商品类型 {normal:一般贸易；保税贸易：tax } -->
        <RadioGroup v-model="formItem.prdType">
          <Radio label="normal">
            <span>一般贸易</span>
          </Radio>
          <Radio label="tax">
            <span>保税贸易</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="商品货源" prop="prdSource">
        <!-- 商品货源 { platform: 平台供货 ；shop: 门店自采} -->
        <RadioGroup v-model="formItem.prdSource">
          <Radio label="platform">
            <span>平台供货</span>
          </Radio>
          <Radio label="shop">
            <span>门店自采</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="供货方式" prop="supplyMode">
        <!-- 供货方式{shop:直供门店 ; customer: 直供用户}-->
        <RadioGroup v-model="formItem.supplyMode">
          <Radio label="shop">
            <span>直供门店</span>
          </Radio>
          <Radio label="customer">
            <span>直供用户</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="C端是否开启线下支付" prop="customerOfflineFlag">
        <!-- C端是否开启线下支付{ 1:开启线下支付 0:不开启 }-->
        <RadioGroup v-model="formItem.customerOfflineFlag">
          <Radio label="0">
            <span>否</span>
          </Radio>
          <Radio label="1">
            <span>是</span>
          </Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="起购数量" prop="leastBuyCnt">
        <Input
          v-model="formItem.leastBuyCnt"
          placeholder="请输入起购数量，仅限数字"
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="步长" prop="buyStep">
        <Input
          v-model="formItem.buyStep"
          placeholder="请输入步长，仅限数字"
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="限购数量" prop="maxBuyCnt">
        <Input
          v-model="formItem.maxBuyCnt"
          placeholder="请输入限购数量，仅限数字"
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="产品规格" prop="prdStandard">
        <Input
          v-model="formItem.prdStandard"
          placeholder="请输入产品规格，仅支持数字"
          style="width: 50%"
        >
          <span slot="append">g</span>
        </Input>
      </FormItem>
      <FormItem label="毛重" prop="rweight">
        <Input
          v-model="formItem.rweight"
          placeholder="请输入毛重，仅支持数字"
          style="width: 50%"
        >
          <span slot="append">g</span>
        </Input>
      </FormItem>
      <FormItem label="包装">
        <Input v-model="formItem.pkgUnit" placeholder="" style="width: 50%">
          <span slot="append">听</span>
        </Input>
      </FormItem>
      <!-- <FormItem label="每听建议食用" prop="eatDays">
        <Input
          v-model="formItem.eatDays"
          placeholder="请输入建议食用天数，仅支持数字"
          style="width: 50%"
        >
          <span slot="append">天</span>
        </Input>
      </FormItem> -->
      <FormItem label="封面图" prop="coverImgUrl">
        <Upload
          v-if="!formItem.coverImgUrl"
          :action="`${baseURL}base/file/publicUpload?scene=SHOP`"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          :on-success="coverImgUploadSuccess"
          :on-error="coverImgUploadError"
          :format="['jpg', 'jpeg', 'png']"
          :headers="{ token: $sessionToken() }"
        >
          <Button icon="ios-cloud-upload-outline" :loading="uploading"
            >上传图片</Button
          >
        </Upload>
        <div v-if="formItem.coverImgUrl" class="main-image">
          <img :src="formItem.coverImgUrl" alt="" />
          <div class="delete" @click="deleteImage('coverImgUrl')"></div>
        </div>
        <p>用于商品列表的展示，建议尺寸300px*300px，只能上传1张，不超过3M。</p>
      </FormItem>
      <FormItem label="主图" prop="mainImgUrlList">
        <Upload
          v-if="
            !formItem.mainImgUrlList ||
            !formItem.mainImgUrlList.length ||
            formItem.mainImgUrlList.length < 5
          "
          :action="`${baseURL}base/file/publicUpload?scene=SHOP`"
          :show-upload-list="false"
          :before-upload="mainImgBeforeUpload"
          :on-success="mainImgUploadSuccess"
          :on-error="mainImgUploadError"
          :format="['jpg', 'jpeg', 'png']"
          :headers="{ token: $sessionToken() }"
        >
          <Button icon="ios-cloud-upload-outline" :loading="mainImgUploading"
            >上传图片</Button
          >
        </Upload>
        <draggable v-model="formItem.mainImgUrlList">
          <transition-group>
            <div
              v-for="(img, index) in formItem.mainImgUrlList"
              :key="img"
              class="main-image"
            >
              <img :src="img" />
              <div
                class="delete"
                @click="deleteImage('mainImgUrlList', index)"
              ></div>
            </div>
          </transition-group>
        </draggable>
        <p>
          用于商品详情轮播展示，建议尺寸750px*750px，上限5张，不超过3M。长按拖动可改变主图的展示顺序。
        </p>
      </FormItem>
      <FormItem label="保质期" prop="periodDays">
        <Input
          v-model="formItem.periodDays"
          placeholder="请输入保质期，仅支持数字"
          style="width: 50%"
        >
          <span slot="append">天</span>
        </Input>
      </FormItem>
      <!-- 
      <FormItem label="罐码" prop="tankCode">
        <Input
          v-model="formItem.tankCode"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="罐码2" prop="tankCode2">
        <Input
          v-model="formItem.tankCode2"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="商品条形码" prop="barCode">
        <Input
          v-model="formItem.barCode"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="appShowName" prop="appShowName">
        <Input
          v-model="formItem.appShowName"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      -->
      <FormItem label="产品简称" prop="erpCode">
        <Input
          v-model="formItem.erpCode"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="是否POS" prop="checkFlag">
        <RadioGroup v-model="formItem.checkFlag">
          <Radio label="1">
            <span>是</span>
          </Radio>
          <Radio label="0">
            <span>否</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <!--      <FormItem label="年龄段" prop="generation">-->
      <!--        <Input-->
      <!--          v-model="formItem.generation"-->
      <!--          placeholder=""-->
      <!--          style="width: 50%"-->
      <!--        ></Input>-->
      <!--      </FormItem>-->
      <!-- <FormItem label="包装数量单位名称" prop="pkgUnitDesc">
        <Input
          v-model="formItem.pkgUnitDesc"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="整箱校验数量" prop="fullPkgNumber">
        <Input
          v-model.number="formItem.fullPkgNumber"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="混搭最小起订量" prop="mixLeastBuyCnt">
        <Input
          v-model.number="formItem.mixLeastBuyCnt"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="是否可以混搭" prop="mixFlag">
        <RadioGroup v-model="formItem.mixFlag">
          <Radio label="0">
            <span>是</span>
          </Radio>
          <Radio label="1">
            <span>否</span>
          </Radio>
        </RadioGroup>
      </FormItem>-->
      <FormItem label="排序">
        <InputNumber v-model="formItem.sortIndex" placeholder=""></InputNumber>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input
          v-model="formItem.remark"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem label="详情图">
        <div id="editor"></div>
      </FormItem>
      <!-- <FormItem v-if="isEdit" label="操作人" prop="lastOptUser">
        <Input
          v-model="formItem.lastOptUser"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem>
      <FormItem v-else label="添加人" prop="addOptUser">
        <Input
          v-model="formItem.addOptUser"
          placeholder=""
          style="width: 50%"
        ></Input>
      </FormItem> -->
      <div class="title">标签</div>
      <FormItem label="标签" prop="labelCodeList">
        <Select
          v-model="formItem.labelCodeList"
          filterable
          multiple
          :label-in-value="true"
          style="width: 50%"
        >
          <Option
            v-for="item in productLabelAll"
            :value="item.code"
            :key="item.code"
            >{{ item.name }}
          </Option>
        </Select>
      </FormItem>
      <div class="title">属性</div>
      <FormItem label="类目" prop="categoryCode">
        <Select
          v-model="formItem.categoryCode"
          style="width: 60%"
          @on-change="checkoutProperty"
        >
          <Option
            v-for="item in productCategoryList"
            :key="item.code"
            :value="item.code"
            >{{ item.name }}
          </Option>
        </Select>
      </FormItem>

      <FormItem label="属性" prop="propertyValueId">
        <RadioGroup
          v-model="formItem.propertyValueId"
          v-if="productPropertyList && productPropertyList.length"
        >
          <Radio
            v-for="item in propertyList"
            :key="item.id"
            :value="item.id"
            :label="item.id"
            >{{ item.value }}
          </Radio>
        </RadioGroup>
        <div v-else>暂无属性</div>
      </FormItem>
      <div class="title">价格信息</div>
      <FormItem label="建议零售价" prop="recommendPrice">
        <Input
          v-model="formItem.recommendPrice"
          placeholder="请输入建议零售价，仅支持数字"
          style="width: 50%"
        >
        </Input>
      </FormItem>
      <FormItem label="分销限价" prop="distributorPriceLimitFlag">
        <!-- 分销限价标志:1 限价 0：不限价 -->
        <RadioGroup v-model="formItem.distributorPriceLimitFlag">
          <Radio label="0">否</Radio>
          <Radio label="1">是</Radio>
        </RadioGroup>
      </FormItem>
      <div v-if="formItem.distributorPriceLimitFlag == 1">
        <FormItem label="分销最低价" prop="distributorMinPrice">
          <Input
            v-model="formItem.distributorMinPrice"
            placeholder="请输入分销最低价，仅支持数字"
            style="width: 50%"
          >
          </Input>
        </FormItem>
        <FormItem label="分销最高价" prop="distributorMaxPrice">
          <Input
            v-model="formItem.distributorMaxPrice"
            placeholder="请输入分销最高价，仅支持数字"
            style="width: 50%"
          >
          </Input>
        </FormItem>
      </div>
      <FormItem label="零售限价" prop="retailPriceLimitFlag">
        <!-- 零售限价标志:1 限价 0：不限价 -->
        <RadioGroup v-model="formItem.retailPriceLimitFlag">
          <Radio label="0">否</Radio>
          <Radio label="1">是</Radio>
        </RadioGroup>
      </FormItem>
      <div v-if="formItem.retailPriceLimitFlag == 1">
        <FormItem label="零售最低价" prop="retailMinPrice">
          <Input
            v-model="formItem.retailMinPrice"
            placeholder="请输入零售最低价，仅支持数字"
            style="width: 50%"
          >
          </Input>
        </FormItem>
        <FormItem label="零售最高价" prop="retailMaxPrice">
          <Input
            v-model="formItem.retailMaxPrice"
            placeholder="请输入零售最高价，仅支持数字"
            style="width: 50%"
          >
          </Input>
        </FormItem>
      </div>
      <FormItem label="云店限价" prop="shopPriceLimitFlag">
        <!-- 云店限价标志:1 限价 0：不限价 -->
        <RadioGroup v-model="formItem.shopPriceLimitFlag">
          <Radio label="0">否</Radio>
          <Radio label="1">是</Radio>
        </RadioGroup>
      </FormItem>
      <div v-if="formItem.shopPriceLimitFlag == 1">
        <FormItem label="云店最低价" prop="shopMinPrice">
          <Input
            v-model="formItem.shopMinPrice"
            placeholder="请输入云店最低价，仅支持数字"
            style="width: 50%"
          >
          </Input>
        </FormItem>
        <FormItem label="云店最高价" prop="shopMaxPrice">
          <Input
            v-model="formItem.shopMaxPrice"
            placeholder="请输入云店最高价，仅支持数字"
            style="width: 50%"
          >
          </Input>
        </FormItem>
      </div>
      <!-- <FormItem label="是否可退换货">
        <RadioGroup v-model="formItem.returnStatus">
          <Radio label="1">是</Radio>
          <Radio label="0">否</Radio>
        </RadioGroup>
      </FormItem> -->
      <FormItem>
        <Button type="primary" @click="save">保存</Button>
        <Button style="margin-left: 8px" @click="cancel">取消</Button>
      </FormItem>
    </Form>

    <Modal v-model="selectSPUModalVisble" title="选择商品SPU" width="70%">
      <Row :gutter="20">
        <Col span="9">
          <Input
            v-model="params.brandCode"
            placeholder="请选择品牌"
            class="search"
          />
        </Col>
        <Col span="9">
          <Input
            v-model="params.name"
            placeholder="请输入名称"
            class="search"
          />
        </Col>
        <Col span="6">
          <Button type="primary" @click="getList">搜索</Button>
          <Button @click="resetList">重置</Button>
        </Col>
        <Col span="24" style="margin-top: 16px">
          <Table
            class="table"
            border
            stripe
            :loading="loading"
            :columns="columns"
            :data="productSpuList.data || []"
            @on-row-click="tableRowClick"
          >
            <template slot-scope="{ row }" slot="action">
              <Radio :value="formItem.spuCode == row.code"></Radio>
            </template>
          </Table>
          <Page
            :style="{ float: 'right', marginTop: '10px' }"
            :total="productSpuList.total"
            show-sizer
            show-total
            prev-text="Previous"
            next-text="Next"
            show-elevator
            @on-change="pageNumChange"
            @on-page-size-change="pageSizeChange"
          />
        </Col>
      </Row>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import E from "wangeditor";
import draggable from "vuedraggable";
import axios from "axios";

const columns = [
  {
    title: "",
    slot: "action",
    width: 80,
  },
  {
    title: "SPU编码",
    key: "code",
  },
  {
    title: "名称",
    key: "name",
  },
  {
    title: "品牌",
    key: "brandName",
  },
  {
    title: "品牌分类",
    key: "categoryName",
  },
];
const formItem = {
  brandName: "", //spu的名称
  name: "", // string商品名称
  prdCode: "", // string产品代码/商品简称
  spuCode: "", // string商品SPU
  brandCode: "", // string商品品牌
  categoryCode: "", // string商品类目
  leastBuyCnt: "", // integer($int32)最小起购量
  buyStep: "", // integer($int32)起购量步长
  prdStandard: "", // string产品规格
  rweight: "", // integer($int32)
  pkgUnit: "", // integer($int32)包装数量，单位：听
  eatDays: "", // integer($int32)每听建议食用天数
  periodDays: "", // integer($int32)保质期天数
  barCode: "", // string商品条形码
  tankCode: "", // string罐码
  tankCode2: "", // string罐码2
  returnStatus: "", // string是否可退换货，0：是；1：否；
  labelCodeList: [], // string标签列表
  propertyCode: "", // string属性
  coverImgUrl: "", // string封面图URL地址
  mainImgUrlList: [], // string主图URL地址,arrayList
  content: "", // string商品内容介绍，富文本

  addOptUser: "", // string添加人
  appShowName: "", // string显示名称
  erpCode: "", // string编商品在达能SAP系统唯一编码
  maxBuyCnt: "", // integer($int32)限购数量，0表示不限购

  // "addOptUser": "", // 添加人
  remark: "", //
  //generation: "", // 年龄段
  mixFlag: "", //   是否可以混搭:0:可混搭  1：不可混搭',
  pkgUnitDesc: "", //  包装数量单位名称',
  fullPkgNumber: "", //  整箱校验数量',
  mixLeastBuyCnt: "", //  混搭最小起订量',

  // 2021-11-30新增
  prdType: "", //商品类型 normal:一般贸易；保税贸易：tax
  prdSource: "", //商品货源 platform: 平台供货 ；shop: 门店自采
  supplyMode: "", //供货方式shop:直供门店 ; customer: 直供用户
  customerOfflineFlag: "", //C端是否开启线下支付 1:开启线下支付 0:不开启
  recommendPrice: "", //建议零售价
  distributorPriceLimitFlag: "", //分销限价标志:1 限价 0：不限价
  retailPriceLimitFlag: "", //零售限价标志:1 限价 0：不限价
  shopPriceLimitFlag: "", //云店限价标志:1 限价 0：不限价
  distributorMaxPrice: "", //分销限价最大
  distributorMinPrice: "", //分销限价最小
  retailMaxPrice: "", //零售限价最大
  retailMinPrice: "", //零食限价最小
  shopMaxPrice: "", //云店限价最小
  shopMinPrice: "", //云店限价最大
  propertyValueId: "",
  spErpCode: "",
};
const validateMainImage = (rule, value, callback) => {
  if (value && value.length) {
    callback();
  } else {
    callback(new Error("主图不能为空"));
  }
};

const validateLabelCodeList = (rule, value, callback) => {
  if (value && value.length) {
    callback();
  } else {
    callback(new Error("标签不能为空"));
  }
};

const validateHandler = (msg, value, callback) => {
  if ("" + value) {
    callback();
  } else {
    callback(new Error(msg));
  }
};

const validateSelfHandler = (msg, rule, value, callback) => {
  if (new RegExp(rule).test("" + value)) {
    callback();
  } else {
    callback(new Error(msg));
  }
};

const params = {
  pageSize: 10,
  pageNum: 1,
  brandCode: "",
  name: "",
};
export default {
  data() {
    const validatePropertyValueId = (rule, value, callback) => {
      if (value) {
        callback();
      } else {
        callback(new Error("属性不能为空"));
      }
    };
    const validateRange = (params, compare, flag) => {
      const lowLimit = "下限值";
      const upLimit = "上限值";
      return (rule, value, callback) => {
        if (!value || Number(value) <= 0) {
          return callback(new Error(`请输入大于的0数字`));
        } else if (value) {
          const paramsValue = this.formItem[params];
          const compareValue = this.formItem[compare];
          if (flag) {
            if (Number(paramsValue) > Number(compareValue) && compareValue) {
              this.formItem[compare] = "";
              return callback(new Error(`${lowLimit}不能大于${upLimit}`));
            } else {
              for (let item of this.$refs.formValidate.fields) {
                if (item.prop === compare) {
                  item.validateState = "";
                  item.validateMessage = "";
                  break;
                }
              }
            }
            callback();
          } else {
            if (Number(paramsValue) < Number(compareValue) && paramsValue) {
              this.formItem[compare] = "";
              return callback(new Error(`${upLimit}不能小于${lowLimit}`));
            } else {
              for (let item of this.$refs.formValidate.fields) {
                if (item.prop === compare) {
                  item.validateState = "";
                  item.validateMessage = "";
                  break;
                }
              }
            }
            callback();
          }
          callback();
        } else {
          callback();
        }
      };
    };
    return {
      formValidate: {
        spErpCode: [
          { required: true, message: "资金商ErpCode不能为空", trigger: "blur" },
        ],
        barCode: [
          { required: true, message: "商品条形码不能为空", trigger: "blur" },
        ],
        brandCode: [{ required: true, message: "请选择品牌", trigger: "blur" }],
        buyStep: [
          {
            required: true,
            validator: (rule, value, callback) =>
              validateHandler("步长不能为空", value, callback),
            trigger: "blur",
          },
          {
            required: true,
            type: "string",
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^\d+$/, value, callback),
            trigger: "blur",
          },
        ],
        categoryCode: [
          { required: true, message: "类目不能为空", trigger: "change" },
        ],
        coverImgUrl: [
          { required: true, message: "封面图不能为空", trigger: "change" },
        ],
        eatDays: [
          {
            required: true,
            validator: (rule, value, callback) =>
              validateHandler("每听建议食用天数不能为空", value, callback),
            trigger: "blur",
          },
          {
            required: true,
            type: "string",
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^\d+$/, value, callback),
            trigger: "blur",
          },
        ],
        erpCode: [
          { required: true, message: "erpCode不能为空", trigger: "blur" },
        ],
        // labelCodeList: [
        //   { required: true, validator: validateLabelCodeList, trigger: "blur" },
        // ],
        leastBuyCnt: [
          {
            required: true,
            validator: (rule, value, callback) =>
              validateHandler("最小起购量不能为空", value, callback),
            trigger: "blur",
          },
          {
            required: true,
            type: "string",
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^\d+$/, value, callback),
            trigger: "blur",
          },
        ],
        mainImgUrlList: [
          { required: true, trigger: "change", validator: validateMainImage },
        ],
        maxBuyCnt: [
          {
            required: true,
            validator: (rule, value, callback) =>
              validateHandler("限购数量不能为空", value, callback),
            trigger: "blur",
          },
          {
            required: true,
            type: "string",
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^\d+$/, value, callback),
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "商品名称不能为空", trigger: "blur" },
        ],
        periodDays: [
          {
            required: true,
            validator: (rule, value, callback) =>
              validateHandler("保质期不能为空", value, callback),
            trigger: "blur",
          },
          {
            required: true,
            type: "string",
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^\d+$/, value, callback),
            trigger: "blur",
          },
        ],
        prdCode: [
          { required: true, message: "产品代码不能为空", trigger: "blur" },
        ],
        prdStandard: [
          { required: true, message: "产品规格不能为空", trigger: "blur" },
          {
            required: true,
            type: "string",
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^\d+$/, value, callback),
            trigger: "blur",
          },
        ],
        rweight: [
          {
            type: "string",
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^\d+$/, value, callback),
            trigger: "blur",
          },
        ],
        propertyValueId: [
          {
            required: true,
            validator: validatePropertyValueId,
            trigger: "change",
          },
        ],
        spuCode: [{ required: true, message: "请选择SPU", trigger: "change" }],
        tankCode: [
          { required: true, message: "罐码不能为空", trigger: "blur" },
        ],
        tankCode2: [
          { required: true, message: "罐码2不能为空", trigger: "blur" },
        ],
        checkFlag: [
          { required: true, message: "请选择是否POS", trigger: "change" },
        ],
        mixFlag: [
          { required: true, message: "请选择是否可以混搭", trigger: "blur" },
        ],
        // addOptUser: [
        //   { required: true, message: '添加人不能为空', trigger: 'blur' }
        // ],
        // lastOptUser: [
        //   { required: true, message: '操作人不能为空', trigger: 'blur' }
        // ],
        // generation: [
        //   { required: true, message: "年龄段不能为空", trigger: "blur" },
        // ],
        pkgUnitDesc: [
          {
            required: true,
            message: "包装数量单位名称不能为空",
            trigger: "blur",
          },
        ],
        fullPkgNumber: [
          {
            required: true,
            type: "number",
            message: "整箱校验数量不能为空",
            trigger: "blur",
          },
        ],
        mixLeastBuyCnt: [
          {
            required: true,
            type: "number",
            message: "混搭最小起订量不能为空",
            trigger: "blur",
          },
        ],
        prdType: [
          { required: true, message: "请选择商品类型", trigger: "change" },
        ],
        prdSource: [
          { required: true, message: "请选择商品货源", trigger: "change" },
        ],
        supplyMode: [
          { required: true, message: "请选择供货方式", trigger: "change" },
        ],
        customerOfflineFlag: [
          {
            required: true,
            message: "请选择是否开启线下支付",
            trigger: "change",
          },
        ],
        recommendPrice: [
          {
            required: true,
            type: "number",
            validator: (rule, value, callback) =>
              // validateSelfHandler("请输入数字", /^\d+$/, value, callback),
              validateSelfHandler(
                "请输入数字,支持两位小数",
                /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                value,
                callback
              ),
            trigger: "blur",
          },
        ],
        distributorPriceLimitFlag: [
          { required: true, message: "请选择是否分销限价", trigger: "change" },
        ],
        retailPriceLimitFlag: [
          { required: true, message: "请选择是否零售限价", trigger: "change" },
        ],
        shopPriceLimitFlag: [
          { required: true, message: "请选择是否云店限价", trigger: "change" },
        ],
        distributorMaxPrice: [
          {
            required: true,
            type: "number",
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "请输入数字,支持两位小数",
                /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                value,
                callback
              ),
            trigger: "blur",
          },
          {
            required: true,
            type: "number",
            validator: validateRange(
              "distributorMaxPrice",
              "distributorMinPrice",
              false
            ),
            trigger: "blur",
          },
        ],
        distributorMinPrice: [
          {
            required: true,
            type: "number",
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "请输入数字,支持两位小数",
                /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                value,
                callback
              ),
            trigger: "blur",
          },
          {
            required: true,
            type: "number",
            validator: validateRange(
              "distributorMinPrice",
              "distributorMaxPrice",
              true
            ),
            trigger: "blur",
          },
        ],
        shopMinPrice: [
          {
            required: true,
            type: "number",
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "请输入数字,支持两位小数",
                /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                value,
                callback
              ),
            trigger: "blur",
          },
          {
            required: true,
            type: "number",
            validator: validateRange("shopMinPrice", "shopMaxPrice", true),
            trigger: "blur",
          },
        ],
        shopMaxPrice: [
          {
            required: true,
            type: "number",
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "请输入数字,支持两位小数",
                /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                value,
                callback
              ),
            trigger: "blur",
          },
          {
            required: true,
            type: "number",
            validator: validateRange("shopMaxPrice", "shopMinPrice", false),
            trigger: "blur",
          },
        ],
        retailMaxPrice: [
          {
            required: true,
            type: "number",
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "请输入数字,支持两位小数",
                /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                value,
                callback
              ),
            trigger: "blur",
          },
          {
            required: true,
            type: "number",
            validator: validateRange("retailMaxPrice", "retailMinPrice", false),
            trigger: "blur",
          },
        ],
        retailMinPrice: [
          {
            required: true,
            type: "number",
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "请输入数字,支持两位小数",
                /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                value,
                callback
              ),
            trigger: "blur",
          },
          {
            required: true,
            type: "number",
            validator: validateRange("retailMinPrice", "retailMaxPrice", true),
            trigger: "blur",
          },
        ],
      },
      formItem: JSON.parse(JSON.stringify(formItem)),
      params: JSON.parse(JSON.stringify(params)),
      selectSPUModalVisble: false,
      tagModalVisible: false,
      loading: false,
      columns,
      propertyList: [],
      labelNameList: [],
      isEdit: false,
      baseURL: "",
      uploading: false,
      mainImgUploading: false,
    };
  },
  computed: {
    ...mapGetters("productSpu", {
      productSpuList: "getProductSpuList",
    }),
    ...mapGetters("productProperty", {
      productPropertyList: "getProductPropertyList",
    }),
    ...mapGetters("category", {
      productCategoryList: "getProductCategoryAll",
    }),
    ...mapGetters("skuInfo", {
      productSkuDetail: "getProductSkuDetail",
    }),
    ...mapGetters("label", {
      productLabelAll: "getProductLabelAll",
    }),
  },
  watch: {
    selectSPUModalVisble: function (newv, oldv) {
      if (newv) this.getList();
    },
    "formItem.categoryCode": {
      immediate: true,
      handler: function (newv, oldv) {
        if (newv) {
          this.$store.dispatch("productProperty/getProductPropertyList", {
            categoryCode: newv,
          });
        }
      },
    },
    productPropertyList: {
      deep: true,
      handler: function (newv, oldv) {
        if (newv[0]) {
          this.formItem.propertyCode = newv[0].code;
          this.propertyList = (newv[0] && newv[0].valueList) || [];
        }
      },
    },
    productSkuDetail: {
      deep: true,
      handler: function (newv, oldv) {
        if (newv.data) {
          this.formItem = newv.data;
        }
      },
    },
  },
  components: {
    draggable,
  },
  created() {
    this.baseURL = axios.defaults.baseURL;
    // 获取类目数据
    this.$store.dispatch("category/getProductCategoryAll", {});
    // 获取标签数据
    this.$store.dispatch("label/getProductLabelAll", {});
  },
  mounted() {
    // 是否是编辑模式
    const code = this.$route.query.code;
    this.isEdit = !!code;
    if (this.isEdit) {
      this.$store
        .dispatch("skuInfo/getProductSkuDetail", {
          skuCode: code,
        })
        .then(() => {
          if (this.productSkuDetail.status !== "success") {
            this.$Message.error(res.message || "查询失败，请稍后重试！");
          }
        })
        .catch((err) => {
          this.$Message.error("查询失败，请稍后重试！");
        })
        .finally(this.editorHandler);

      this.formValidate.addOptUser = [];
      this.formValidate.lastOptUser = [
        { required: true, message: "操作人不能为空", trigger: "blur" },
      ];
    } else {
      this.editorHandler();
      this.formValidate.addOptUser = [
        { required: true, message: "添加人不能为空", trigger: "blur" },
      ];
      this.formValidate.lastOptUser = [];
    }
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("productSpu/getProductSpuList", this.params)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 页码
    pageNumChange(pageNum) {
      this.params.pageNum = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      // 页码变动触发pageNumChange
      if (this.params.pageNum == 1) {
        this.getList();
      } else {
        this.params.pageNum = 1;
      }
    },
    // 重置
    resetList() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.params.searchName = "";
      this.getList();
    },
    tableRowClick(row, index) {
      // this.formItem.addOptUser = row.addOptUser;
      this.formItem.brandCode = row.brandCode;
      const labels = Array.from(
        new Set(this.formItem.labelCodeList.concat(row.labelCodeList))
      );
      this.$set(this.formItem, "labelCodeList", labels);
      this.formItem.brandName = row.name;
      this.formItem.spuCode = row.code;
    },
    beforeUpload() {
      this.uploading = true;
    },
    coverImgUploadSuccess(response, file, fileList) {
      if (response.code == "200") {
        this.formItem.coverImgUrl = response.data.url;
      } else {
        this.$Message.error(response.message || "上传失败");
      }
      this.uploading = false;
    },
    coverImgUploadError() {
      this.formItem.coverImgUrl = "";
      this.uploading = false;
      this.$Message.error("上传失败");
    },
    mainImgBeforeUpload() {
      this.mainImgUploading = true;
    },
    mainImgUploadSuccess(response, file, fileList) {
      if (response.code == "200") {
        if (this.formItem.mainImgUrlList == undefined) {
          this.formItem.mainImgUrlList = [];
        }

        this.formItem.mainImgUrlList.push(response.data.url);
      } else {
        this.$Message.error(response.message || "上传失败");
      }
      this.mainImgUploading = false;
    },
    mainImgUploadError() {
      this.mainImgUploading = false;
      this.$Message.error("上传失败");
    },
    deleteImage(target, index) {
      if (target === "coverImgUrl") {
        this.formItem.coverImgUrl = "";
      } else if (target === "mainImgUrlList") {
        this.formItem.mainImgUrlList.splice(index, 1);
      }
    },
    editorHandler() {
      const self = this;
      const editor = new E("#editor");
      editor.config.customUploadImg = function (resultFiles, insertImgFn) {
        const fd = new FormData();
        fd.append("file", resultFiles[0]);
        self.$store
          .dispatch("uploadImage", fd)
          .then((res) => {
            if (res.code == 200) {
              insertImgFn(res.data.url);
            } else {
              self.$Message.error("图片上传失败");
            }
          })
          .catch((err) => {
            self.$Message.error("图片上传失败");
          });
      };
      // 配置 onchange 回调函数
      editor.config.onchange = function (newHtml) {
        self.formItem.content = newHtml;
      };
      // 配置触发 onchange 的时间频率，默认为 200ms
      editor.config.onchangeTimeout = 500;
      editor.create();
      editor.txt.html(this.formItem.content); // 重新设置编辑器内容
    },
    save() {
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          this.$Spin.show();
          this.$store
            .dispatch(
              this.isEdit
                ? "skuInfo/productSkuUpdate"
                : "skuInfo/productSkuAdd",
              this.formItem
            )
            .then((res) => {
              if (res.code == 200) {
                this.$Message.success(this.isEdit ? "编辑成功" : "添加成功");
                setTimeout(this.cancel, 3000);
              } else {
                this.$Message.error(
                  res.message || this.isEdit
                    ? "编辑失败，请稍后重试！"
                    : "添加失败，请稍后重试！"
                );
              }
            })
            .catch((err) => {
              console.error(err);
              this.$Message.error(err);
            })
            .finally(this.$Spin.hide);
        } else {
        }
      });
    },
    cancel() {
      this.$router.back();
    },
    checkoutProperty() {
      this.formItem.propertyValueId = "";
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 16px;
  font-weight: 700;
  padding-left: 8px;
  color: #333;
  padding: 20px 0;
  margin: 40px 0 0 0;
  border-top: 1px solid #eaecf0;
}

.title:first-child {
  border-top: none;
  margin: 0;
}

.main-image {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  background-color: #f8f9fa;
  border: 1px solid #dcdfe6;
  margin-right: 20px;
  margin-top: 10px;
  overflow: hidden;
}

.main-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.main-image .delete {
  display: none;
  position: absolute;
  height: 20px;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.main-image .delete::after {
  content: " ";

  display: inline-block;
  height: 20px;
  width: 14px;
  background-image: url(data:image/png;base64,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);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.main-image:hover .delete {
  display: block;
}

#editor {
  position: relative;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/skuInfo/add.vue